import { createClient } from 'data-api'
import { COOKIE_NAME_JWT } from '../../constants'
import { clientJwtRequestInterceptor, formatGroupCookieName } from '../../utils'

let client = null

export const initClient = ({ baseURL, storeCode, groupId }) => {
	client = createClient({
		baseURL,
		headers: {
			...(storeCode ? { store: storeCode } : {}),
		},
	})

	client.interceptors.request.use(clientJwtRequestInterceptor(formatGroupCookieName(groupId, COOKIE_NAME_JWT)), null, {
		synchronous: true,
	})

	return client
}

export const getClient = () => client
